import React, { Fragment } from "react";
import * as Styles from "../common/styles/ResultsAem";
import { TradeInAemLabel } from "../../../utils/labels";
import { useTradeInAemSelector } from "../../../redux/store";
import { tradeInAemContactTextItemIds } from "../../../utils/constants";

const TradeInAemContactBlock = (): JSX.Element => {
    const contactFormData = useTradeInAemSelector((state) => state.tradeInAemContact);
    return (
        <>
            <TradeInAemLabel label="tradeInAemSummaryYourDetails" />
            <Styles.Card>
                <Styles.CardBody>
                    <Styles.List>
                        {tradeInAemContactTextItemIds.map((textItemId) =>
                            contactFormData[textItemId]?.value ? (
                                <Fragment key={contactFormData[textItemId]?.label}>
                                    <dt>{contactFormData[textItemId]?.label}</dt>
                                    <dd>{contactFormData[textItemId]?.value}</dd>
                                </Fragment>
                            ) : null,
                        )}
                    </Styles.List>
                </Styles.CardBody>
            </Styles.Card>
        </>
    );
};
export default TradeInAemContactBlock;
